// extracted by mini-css-extract-plugin
module.exports = {"container":"GridList_container__JuUhz","large":"GridList_large__2oU72"};